import styled from 'styled-components';
import { Block } from 'style/styleComponent/styled';

export const Container = styled.div``;

export const ContentWrapper = styled.div`
  border-radius: 8px;
  font-family: 'inter-regular', sans-serif;
`;

export const BlockHeader = styled(Block)`
  border-radius: 8px 8px 0 0;
`;

export const BlockFooter = styled(Block)`
  border-radius: 0 0 8px 8px;
`;

export const TableGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 8px;
  align-items: stretch;
  margin-bottom: 24px;
`;

export const TableStyle = styled.div`
  display: grid;
  background-color: white;
  padding: 10px;
  border-radius: 8px;
  grid-template-rows: auto 54px;
`;

export const LabelSelectProduct = styled.span`
  color: var(--BTN-TEXT-SECONDARY-default);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5714285714285714;
`;